import { data } from '../../svg/Automation/data';
import { makeIcon } from '../makeIcon';

export const Automation = makeIcon(data, 'automation', 'Automation');

export default Automation;
